export default "__VITE_ASSET__aa872029__"